import { useMemo } from 'react';
import { Input, InputLabel, FormControl, MenuItem, Select, Chip, FormHelperText, ListSubheader } from '@material-ui/core';
import { shouldBeLocked } from '../utils/Roles'

const MultiDropDownObjects = ({
  categories,
  categoryAccessor,
  optionDisabled,
  required = false,
  formStyle,
  labelStyle,
  selectStyle,
  chipsStyle,
  chipStyle,
  id,
  title,
  helperText,
  helperTextStyle,
  stateName,
  handleChange,
  selectedValues,
  options,
  menuName = "name",
  chipName = "name",
  disabled = undefined,
  nameFormatter,
  bgColor,
  userRoles,
  nameFormatterForChip = true,
  canEdit,
  ...props
}) => {
  const localCanEdit = canEdit ?? props?.canEdit
  const memoizedLocked = useMemo(() => shouldBeLocked(disabled, localCanEdit, userRoles), [disabled, localCanEdit, userRoles]);

  if (!id) {
    id = 'undefined-id'
  }
  const width = title?.length ? title?.length + 'ch' : title?.helperText + 'ch'

  return (
    <FormControl className={formStyle || ""}>
      {title && <InputLabel shrink={true} className={labelStyle || ""} id={title + "-input-label"}>{title}</InputLabel>}

      <Select
        required={required}
        disabled={memoizedLocked}
        data-cy={title + "-select"}
        inputProps={{ "data-cy": title + "-input" }}
        labelId={title + "-input-label"}
        id={id}
        multiple
        value={selectedValues}
        onChange={handleChange}
        name={stateName}
        input={<Input data-cy={title + "-input"} id={id + "-ori-chip"} />}
        // MenuProps={MenuProps}
        className={selectStyle || ""}
        style={{ minWidth: width, backgroundColor: bgColor ? bgColor : "" }}
        renderValue={selected => (
          <div className={chipsStyle}>
            {selected.map((value, index) => (
              <Chip
                key={value?.id + "-" + index}
                label={nameFormatter && nameFormatterForChip ? nameFormatter(value) : value[chipName]}
                className={chipStyle}
                data-cy={title + "-chip"}
                size="small"

              />
            ))
            }
          </div>
        )}
      >
        {/* {options.map((option, index) => ( */}
        {categories
          ?
          categories.map((category, index) => {
            let array = [<ListSubheader style={{ pointerEvents: "none" }} key={category + "-" + index} disableSticky={true}>{category}</ListSubheader>]
            options.map((option, i) => (option[categoryAccessor] === category) ? array.push(<MenuItem disabled={optionDisabled ? optionDisabled(option) : false} key={option?.id + "-" + i} value={option}>{nameFormatter ? nameFormatter(option) : option[menuName]}</MenuItem>) : null)
            return (array)
          })
          :
          options && options.sort((a, b) => a?.position - b?.position).map((option, index) => (
            <MenuItem disabled={optionDisabled ? optionDisabled(option) : false} data-cy={title + "-multiselect-options-" + index} key={option?.id + "-" + index} value={option}>
              {nameFormatter ? nameFormatter(option) : option[menuName]}
            </MenuItem>
          ))
        }
      </Select>
      <FormHelperText className={helperTextStyle}>{helperText}</FormHelperText>
    </FormControl>
  )
}

export default MultiDropDownObjects;